import { text } from "@nozbe/watermelondb/decorators";
import { BaseModel } from "./Base";

export default class SerialNumber extends BaseModel {
  static table = "serial_numbers";
  @text("productLocationInventoryPricingId")
  productLocationInventoryPricingId: string;

  @text("value") value: string;
}
